import { Typography } from '@mui/material';
import { Stack } from '@mui/system';
import * as React from 'react';
import { BarChart as ReBarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip } from 'recharts';

import type { ChartData } from '../../common/types/charts';

type Props = {
  data: ChartData[];
};

function BarChart({ data }: Props) {
  const tick = data.reduce((prevValue: number[], { value }: ChartData) => {
    if (prevValue.includes(value)) {
      return prevValue;
    }
    return prevValue.concat([value]);
  }, []);

  return (
    <ReBarChart
      width={400}
      height={300}
      data={data}
      margin={{
        top: 5,
        right: 10,
        left: 10,
        bottom: 5,
      }}
    >
      <CartesianGrid strokeDasharray='3 3' vertical={false} />
      <XAxis dataKey='name' />
      <YAxis width={30} domain={tick} tickCount={tick.length} />
      <Tooltip
        content={({ active, payload, label }) => {
          if (active && payload != null) {
            return (
              <Stack
                direction='row'
                p='5px 10px'
                sx={{ backgroundColor: 'white', borderRadius: '5px', border: '1px solid lightgrey' }}
              >
                <Typography>
                  {label}: {payload[0].value}
                </Typography>
              </Stack>
            );
          }
        }}
      />
      <Bar dataKey='value' fill='#8884d8' />
    </ReBarChart>
  );
}

export default BarChart;
